import SlotRow from './SlotRow';
import AddSlotForm from './AddSlotForm';
import type { State } from '../state';

interface SlotsPanelProps {
  state: State;
  config: { month: number; year: number };
  slug: string;
  selectedDate: string;
  username: string;
}

export default function SlotsPanel({
  state,
  config,
  slug,
  selectedDate,
  username,
}: SlotsPanelProps) {
  const selectedSlots = selectedDate
    ? state.slotsByDate[selectedDate] || []
    : [];
  const userReactionBySlot = state.userReactionBySlot || {};

  return (
    <div className="flex-1 min-w-0 overflow-y-auto p-4 bg-white dark:bg-gray-950 border-2 border-black dark:border-gray-100">
      <div className="flex flex-col gap-4">
        {selectedDate ? (
          <div key={selectedDate}>
            <h3 id={`day-${selectedDate}`} className="text-lg font-semibold mt-0 mb-2">
              Slots for {selectedDate}
            </h3>
            {selectedSlots.length === 0 ? (
              <p className="text-gray-600 dark:text-gray-400">
                No slots. Add one below.
              </p>
            ) : null}
            {selectedSlots.map((slot) => (
              <SlotRow
                key={slot.id}
                slot={slot}
                slug={slug}
                username={username}
                currentUserEmoji={userReactionBySlot[slot.id]}
                reactionsByUser={state.reactionsByUserBySlot?.[slot.id]}
                existingTags={Object.values(state.tagsById || {})}
              />
            ))}
            <AddSlotForm slug={slug} selectedDate={selectedDate} username={username} config={config} />
          </div>
        ) : (
          <p className="text-gray-600 dark:text-gray-400">
            Click a day to see slots.
          </p>
        )}
      </div>
    </div>
  );
}
